import * as React from 'react';
import autobind from "autobind-decorator";
import { resolve } from "inversify-react";

import { DocumentTemplateListDataService } from "src/app/general/document-templates/list/document-template-list.data";
import { DocumentTemplateEditorView } from "./document-template-editor.view";

interface DocumentTemplateEditorControllerProps {
	usage: DocumentGenerationUsage;
	marketId?: number;
	brandId?: number;
    value: number;
	mode: ControlMode;
	onChanged: (value: IDocumentTemplateSummary) => void;
    setBusy(isBusy: boolean);
    label?: string;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class DocumentTemplateEditorController extends React.Component<DocumentTemplateEditorControllerProps, any> {
    protected docTemplateDataService: DocumentTemplateListDataService;

    public constructor(props) {
        super(props);
        this.docTemplateDataService = DocumentTemplateListDataService.make();
    }

	@autobind
	protected docTemplateQuery(q?: string): Promise<QueryResult<IDocumentTemplateSummary>> {
		return new Promise<QueryResult<IDocumentTemplateSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.docTemplateDataService.addSorting('id', 'asc', true);
			this.docTemplateDataService.searchKeywords = q;
			this.docTemplateDataService.params.usages = this.props.usage;
			if (this.props.marketId) {
				this.docTemplateDataService.params.marketId = this.props.marketId;
			}
			if (this.props.brandId) {
				this.docTemplateDataService.params.brandId = this.props.brandId;
			}
			this.docTemplateDataService.load(query => query)
				.then(res => {
					this.props.setBusy(false);
					resolve({
						items: res,
						totalCount: this.docTemplateDataService.count
					});
				});
		});
	}

    public render() {
        return (
            <DocumentTemplateEditorView
                onGetErrorMessage={this.props.onGetErrorMessage}
                docTemplateRequest={{ query: this.docTemplateQuery, dataSet: this.docTemplateDataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				mode={this.props.mode}
				label={this.props.label}
				required={this.props.required}
			/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/parts/document-template-editor.controller.tsx